var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['image-container', _vm.slice.sliceLabel]},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }